import { render, staticRenderFns } from "./AttributeValueComponent.vue?vue&type=template&id=436eb03b&scoped=true&"
import script from "./AttributeValueComponent.vue?vue&type=script&lang=js&"
export * from "./AttributeValueComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436eb03b",
  null
  
)

export default component.exports